import React from "react";
import "assets/styles/ecommerce/SecurityInfo.scss";

const SecurityInfo = () => {
  return (
    <div className={'securityInfoWrapper'}>
      <div className={'securityInfo'}>
        <p className={'intro'}>
          Acepta los pagos de tus clientes en tu página web de manera segura y eficiente.
        </p>

        <p>
          Nos adaptamos a las necesidades de tu negocio; si así lo requieres, puedes solicitar pagos recurrentes y meses sin intereses.
        </p>

        <p>
          <strong>En Etomin, la seguridad de nuestros clientes es una prioridad.</strong> Por eso, todos nuestros pagos en línea cuentan con herramientas avanzadas de monitoreo y prevención de fraude, como <strong>Kount</strong> y <strong>G2 Risk</strong>, líderes en el sector de protección de transacciones digitales.
        </p>

        <p>
          Estas soluciones nos permiten analizar en tiempo real cada operación, detectar comportamientos sospechosos y garantizar que tus transacciones sean seguras, confiables y protegidas.
        </p>
      </div>
    </div>
  );
};

export default SecurityInfo;
